import { render, staticRenderFns } from "./cms-block-inline.vue?vue&type=template&id=934a1a0a&scoped=true"
import script from "./cms-block-inline.vue?vue&type=script&lang=js"
export * from "./cms-block-inline.vue?vue&type=script&lang=js"
import style0 from "./cms-block-inline.vue?vue&type=style&index=0&id=934a1a0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "934a1a0a",
  null
  
)

export default component.exports